import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "7583bd75-3977-4733-aa3e-164b266e50a1",
    content: "Pure signal at one frequency",
    options: {},
  },
  {
    id: "f9544be9-f4f5-40b1-8266-8999a0b7ac9c",
    content: "Dirac δ",
    options: {},
  },
  {
    id: "ea5d546f-17cb-4f97-8b48-a1b7e1b9885c",
    content: "Rectangular window",
    options: {},
  },
  {
    id: "8b23d97e-9ea5-445c-8efe-525433e603ab",
    content: "None of them",
    options: {},
  },
];

export const task: Task = {
  id: "f7c17963-f706-4080-add0-efc4a510d684",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    shuffle: true,
    columns: 4,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["f9544be9-f4f5-40b1-8266-8999a0b7ac9c"],
};
